import { ReportResource } from '@mode/shared/data-access-webapp';
import { headerReportData } from '@mode/reports/domain';
import { createSelector } from 'reselect';

export namespace ApiFeatureSelectors {
  export const getCanEditSelectedReport = createSelector(
    headerReportData,
    (resource: ReportResource) => !!resource?._forms?.['edit']
  );

  export const getCanCreateSelectedReportSubscription = createSelector(
    headerReportData,
    (resource: ReportResource) => !!resource?._embedded?.['new_report_subscription']
  );
}
